import { useFela } from 'react-fela';
import { useIntl } from 'react-intl';
import { Navigate } from 'react-router-dom-v5-compat';

import config from '@/config';
import { AdminFirewall, NonDemoFirewall } from '@/modules/auth/components';
import { Tabs } from '@/modules/ui';

import { PeopleTabContent } from '../PeopleTabContent';
import * as felaRules from './UserAdministrationPage.rules';

export const UserAdministrationPage = () => {
    const { css } = useFela();

    const { formatMessage } = useIntl();

    return (
        <NonDemoFirewall>
            <div className={css(felaRules.container)}>
                <AdminFirewall firewall={<Navigate to={config.routes.home} />}>
                    <Tabs
                        items={[
                            {
                                key: 'people',
                                label: formatMessage({ id: 'user-administration.tabs.people' }),
                                children: <PeopleTabContent />,
                            },
                            /*
                        TODO: We've decided to not support groups for now. Remove completely if we don't need it in the future.
                    {
                        key: 'groups',
                        label: formatMessage({ id: 'user-administration.tabs.groups' }),
                        children: <GroupsTabContent />,
                    }, */
                        ]}
                        customStyle={felaRules.tabContainer}
                    />
                </AdminFirewall>
            </div>
        </NonDemoFirewall>
    );
};
